/**
 *
 * Asynchronously loads the component for AdminLayout
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
